export default __webpack_public_path__ + "static/media/DSC08386.7a074846.JPG";